module.exports = __webpack_public_path__ + "img/annual_certificate_logo.08653def.svg";